export default __webpack_public_path__ + "static/media/Serie-A-Money.8a708bf3.svg";